module.exports = __webpack_public_path__ + "static/img/banner_ys.7e7f9c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/banner/banner_ys.png
// module id = gsnb
// module chunks = 15